import { render, staticRenderFns } from "./BasisInfo.vue?vue&type=template&id=07878f74&scoped=true"
import script from "./BasisInfo.vue?vue&type=script&lang=js"
export * from "./BasisInfo.vue?vue&type=script&lang=js"
import style0 from "./BasisInfo.vue?vue&type=style&index=0&id=07878f74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07878f74",
  null
  
)

export default component.exports